module.exports = __webpack_public_path__ + "img/notice.5a07f3d9.png";